import { createContext } from "react";

export const DisableContext = createContext({
    disablevalue:{},
    setDisableValue :(disablevalue) =>{}

});